var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-input-group",
        [
          _c("b-form-input", {
            staticStyle: { width: "140px" },
            attrs: {
              id: "input_users",
              size: "sm",
              type: "text",
              readonly: "",
              disabled: _vm.isDisabled
            },
            model: {
              value: _vm.selectedTitle,
              callback: function($$v) {
                _vm.selectedTitle = $$v
              },
              expression: "selectedTitle"
            }
          }),
          _vm._v(" "),
          _c(
            "b-input-group-append",
            [
              _c(
                "b-btn",
                {
                  attrs: {
                    size: "sm",
                    variant: "outline-success",
                    disabled: _vm.isDisabled
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.showModal.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("Выбрать")]
              ),
              _vm._v(" "),
              _c(
                "b-btn",
                {
                  attrs: {
                    size: "sm",
                    variant: "secondary",
                    disabled: _vm.isDisabled
                  },
                  on: {
                    click: function($event) {
                      $event.stopPropagation()
                      return _vm.onClearSelected.apply(null, arguments)
                    }
                  }
                },
                [_c("font-awesome-icon", { attrs: { icon: "times-circle" } })],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "users_multi_select_modal",
          attrs: {
            id: "users-multi-select-modal",
            "body-class": "modal-body-select",
            title: "Сотрудники",
            size: "xl",
            scrollable: ""
          },
          on: { close: _vm.onCancel },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "w-100" },
                    [
                      _c("p", { staticClass: "float-left" }, [
                        _vm._v("Выбраны: " + _vm._s(_vm.tempSelected.length))
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "mr-1 float-right",
                          attrs: { variant: "primary", size: "sm" },
                          on: { click: _vm.onOk }
                        },
                        [_vm._v("\n          Применить\n        ")]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "b-navbar",
            { attrs: { id: "modal-filters" } },
            [
              _c(
                "b-navbar-nav",
                [
                  _c(
                    "b-input-group",
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "input_search",
                          size: "sm",
                          placeholder: "Поиск",
                          autocomplete: "off"
                        },
                        model: {
                          value: _vm.query,
                          callback: function($$v) {
                            _vm.query = $$v
                          },
                          expression: "query"
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { size: "sm" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.onClearQuery.apply(null, arguments)
                                }
                              }
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: "times-circle" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c("b-table", {
            ref: "locations",
            staticClass: "mb-0 table-centered text-small modal-sticky",
            attrs: {
              id: "modal-multiselect",
              striped: "",
              small: "",
              hover: "",
              responsive: "",
              "show-empty": "",
              "empty-text": _vm.$t("message.common.emptyTable"),
              busy: _vm.isBusy,
              items: _vm.items,
              fields: _vm.fields,
              "tbody-tr-class": _vm.tbodyRowClass,
              "no-provider-filtering": "",
              "no-provider-paging": "",
              "no-provider-sorting": "",
              "sticky-header": "",
              "head-variant": "light"
            },
            on: {
              "update:busy": function($event) {
                _vm.isBusy = $event
              },
              "row-clicked": _vm.rowClicked
            }
          }),
          _vm._v(" "),
          _c("pagination-footer", {
            attrs: { "total-rows": _vm.totalRows, "per-page": _vm.perPage },
            on: {
              "update:perPage": function($event) {
                _vm.perPage = $event
              },
              "update:per-page": function($event) {
                _vm.perPage = $event
              },
              "page-click": _vm.onPagination,
              "per-page-change": _vm.onPerPageChange
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53a96b23", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53a96b23","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Users/UserMultiSelect.vue
// module id = null
// module chunks = 